var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileJoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2176_12938)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6973 6.3158C11.1115 6.3158 11.4473 6.65158 11.4473 7.0658L11.4473 17.0658C11.4473 17.48 11.1115 17.8158 10.6973 17.8158C10.2831 17.8158 9.94727 17.48 9.94727 17.0658L9.94727 7.0658C9.94727 6.65158 10.2831 6.3158 10.6973 6.3158Z",
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1445 6.3158C13.5587 6.3158 13.8945 6.65158 13.8945 7.0658L13.8945 17.0658C13.8945 17.48 13.5587 17.8158 13.1445 17.8158C12.7303 17.8158 12.3945 17.48 12.3945 17.0658L12.3945 7.0658C12.3945 6.65158 12.7303 6.3158 13.1445 6.3158Z",
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.52842e-07 12.3388C-1.45615e-07 12.1734 0.0619019 12.036 0.185706 11.9264C0.309509 11.8168 0.462919 11.7621 0.645933 11.7621L6.80383 11.7621L4.65072 9.82835C4.52153 9.71233 4.45694 9.57595 4.45694 9.41922C4.45694 9.26249 4.51872 9.12713 4.6423 9.01314C4.7771 8.89916 4.93134 8.84216 5.10502 8.84216C5.27871 8.84216 5.42871 8.90017 5.55502 9.0162L8.80622 11.9361C8.87799 12.0005 8.92823 12.0659 8.95694 12.132C8.98565 12.1982 9 12.2691 9 12.3447C9 12.4204 8.98565 12.4904 8.95694 12.5549C8.92823 12.6193 8.87799 12.6838 8.80622 12.7482L5.55502 15.6681C5.42584 15.7842 5.27512 15.8422 5.10287 15.8422C4.93062 15.8422 4.7771 15.7842 4.6423 15.6681C4.51872 15.5521 4.45694 15.4167 4.45694 15.2621C4.45694 15.1074 4.52153 14.972 4.65072 14.856L6.80383 12.9223L0.645933 12.9223C0.462919 12.9223 0.309509 12.8664 0.185706 12.7545C0.0619019 12.6427 -1.60068e-07 12.5041 -1.52842e-07 12.3388Z",
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8418 12.3388C23.8418 12.1734 23.7799 12.036 23.6561 11.9264C23.5323 11.8168 23.3789 11.7621 23.1959 11.7621L17.038 11.7621L19.1911 9.82835C19.3203 9.71233 19.3849 9.57595 19.3849 9.41922C19.3849 9.26249 19.3231 9.12713 19.1995 9.01314C19.0647 8.89916 18.9105 8.84216 18.7368 8.84216C18.5631 8.84216 18.4131 8.90017 18.2868 9.0162L15.0356 11.9361C14.9638 12.0005 14.9136 12.0659 14.8849 12.132C14.8562 12.1982 14.8418 12.2691 14.8418 12.3447C14.8418 12.4204 14.8562 12.4904 14.8849 12.5549C14.9136 12.6193 14.9638 12.6838 15.0356 12.7482L18.2868 15.6681C18.416 15.7842 18.5667 15.8422 18.7389 15.8422C18.9112 15.8422 19.0647 15.7842 19.1995 15.6681C19.3231 15.5521 19.3849 15.4167 19.3849 15.2621C19.3849 15.1074 19.3203 14.972 19.1911 14.856L17.038 12.9223L23.1959 12.9223C23.3789 12.9223 23.5323 12.8664 23.6561 12.7545C23.7799 12.6427 23.8418 12.5041 23.8418 12.3388Z",
    fill: "#334155"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2176_12938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileJoints);
export default __webpack_public_path__ + "static/media/profile-joints.f5179be0424c7d77a6e2d834de54cd65.svg";
export { ForwardRef as ReactComponent };